import React, { Component } from 'react';
import { Loader, Container } from 'semantic-ui-react';

import UTMProfilesList from './UTMProfilesList';
import ManageUTMProfile from './ManageUTMProfile';
import {
  getUtmProfiles,
  deleteUtmProfile
} from '../../services/UtmProfilesService';
import './UTMProfiles.css';

class UTMProfiles extends Component {
  state = {
    section: 'search',
    loading: false,
    utmProfiles: []
  };

  componentDidMount() {
    this.props.setSectionTitle('UTM Profiles');
    this.props.saveGTMEvent('UTM Profiles', 'Alexia');

    this.fetchUTMProfiles();
  }

  fetchUTMProfiles = async () => {
    const response = await getUtmProfiles();
    this.setState({ utmProfiles: response.utmProfiles });
  };

  newUTMProfile = () => {
    this.setState({ section: 'newUTMProfile', utmProfileToEdit: '' });
  };

  editUtmProfile = (utmProfile) => {
    this.setState({ section: 'newUTMProfile', utmProfileToEdit: utmProfile });
  };

  deleteUtmProfile = async (id) => {
    await deleteUtmProfile(id);
    this.fetchUTMProfiles();
  };

  searchPage = () => {
    this.setState({ section: 'search', utmProfileToEdit: '' });
    this.fetchUTMProfiles();
  };

  render() {
    const { section, loading, utmProfiles, utmProfileToEdit } = this.state;
    return (
      <Container fluid>
        {loading && (
          <div className="package-builder-loading">
            <span>
              {' '}
              <Loader inline className="active" /> Loading...{' '}
            </span>
          </div>
        )}

        {!loading && section === 'search' && (
          <UTMProfilesList
            newUTMProfile={this.newUTMProfile}
            utmProfiles={utmProfiles}
            searchPage={this.searchPage}
            editUtmProfile={this.editUtmProfile}
            deleteUtmProfile={this.deleteUtmProfile}
            fetchUTMProfiles={this.fetchUTMProfiles}
          />
        )}
        {section === 'newUTMProfile' ? (
          <ManageUTMProfile
            searchPage={this.searchPage}
            utmProfileToEdit={utmProfileToEdit}
          />
        ) : null}
      </Container>
    );
  }
}

export default UTMProfiles;



// WEBPACK FOOTER //
// ./src/screens/UTMProfiles/UTMProfiles.js